import type { IHierarchyKeyObjectives } from '../model/modalTypes'

type TExpansionItem = Pick<IHierarchyKeyObjectives, 'key' | 'parent' | 'HasChildren'>

export const getSingleRootExpansionKeys = (
  items: readonly TExpansionItem[],
  expandToLeaves: boolean
): string[] => {
  const roots = items.filter((item) => item.parent === undefined || item.parent === null)
  if (roots.length !== 1 || !roots[0].HasChildren) return []
  if (!expandToLeaves) return [roots[0].key]

  const children = new Map<string, TExpansionItem[]>()
  for (const item of items) {
    if (item.parent) {
      const siblings = children.get(item.parent) ?? []
      siblings.push(item)
      children.set(item.parent, siblings)
    }
  }

  const expanded: string[] = []
  const visited = new Set<string>()
  const pending = [roots[0]]
  while (pending.length) {
    const item = pending.pop()
    if (!item || visited.has(item.key)) continue
    visited.add(item.key)
    if (!item.HasChildren) continue

    expanded.push(item.key)
    pending.push(...(children.get(item.key) ?? []).slice().reverse())
  }

  return expanded
}
